<template>
    <tr>
      <td>
        <span>{{ name }}</span>
        <br v-if="remark" />
        <span class="remark silver">{{ remark }}</span>
      </td>
      <td>
        <div class="flexV">
          <input
            :class="customizeStyle"
            :type="dtype"
            :placeholder="placeholder"
            v-model="inputValue"
            @keyup.enter="save"
            @keyup="updateValue"
          />
          <a class="save" v-show="saveIconStatus" @click="save()"
            ><font-awesome-icon icon="save"
          /></a>
        </div>
        <slot></slot>
      </td>
    </tr>
</template>
<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  components: {
    "font-awesome-icon": FontAwesomeIcon
  },
  props: {
    code: String,
    name: String,
    value: [String, Number],
    placeholder: String,
    dbTable: String,
    remark: String,
    dtype: {
      type: String,
      default: function() {
        return "text";
      }
    },
    customizeStyle: {
      type: Object,
      default: function() {
        return { input: true };
      }
    },
    form: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      type: "string",
      inputValue: this.value
    };
  },
  computed: {
    saveIconStatus() {
      return this.value !== this.inputValue && !this.form;
    }
  },
  methods: {
    updateValue() {
      if (this.form) {
        this.$emit("input", this.inputValue);
      }
    },
    save: function() {
      if (this.form) {
        // this.$emit("input", this.inputValue);
      } else {
        console.log("save");
        if (this.inputValue !== this.value) {
          this.$emit("input", this.inputValue);
          this.$emit("update-input", {
            code: this.code,
            name: this.name,
            dbTable: this.dbTable,
            mutation: this.inputValue,
            origin: this.value,
            type: this.type,
            warning: this.saveIconStatus
          });
        }
      }
    },
    emitEditStatusEventToParent() {
      let changeStatusData = {
        code: this.code,
        warning: this.saveIconStatus
      };
      this.$emit("change-edit-status", changeStatusData);
    }
  },
  watch: {
    saveIconStatus: function(newVal, oldVal) {
      this.emitEditStatusEventToParent();
    }
  }
};
</script>
<style scoped src="../../../src/assets/css/shop-console.css"></style>
